import React, { useEffect, useState } from 'react';
import styles from './ImagePreview.module.scss';
import closeSvg from '../assets/close.svg';
import Loader from 'component/atom/loader/Loader';

const ImagePreview = ({ src, isLoading, handleChange }) => {
  const [previewSrc, setPreviewSrc] = useState(null);

  useEffect(() => {
    if (src instanceof File) {
      const objectURL = URL.createObjectURL(src);
      setPreviewSrc(objectURL);

      return () => URL.revokeObjectURL(objectURL);
    } else {
      setPreviewSrc(src);
    }
  }, [src]);

  const handleClear = () => {
    handleChange(null);
  };

  return (
    <div className={styles['image-preview']}>
      <img
        className={styles['svg']}
        src={closeSvg}
        alt="Close"
        onClick={handleClear}
      />
      {previewSrc ? (
        <img className={styles['image']} src={previewSrc} alt="Preview" />
      ) : (
        <p>No Image Selected</p>
      )}
      {isLoading && (
        <div className={styles['backdrop']}>
          <Loader isComponent />
        </div>
      )}
    </div>
  );
};

export default ImagePreview;
